import React, {useState, useEffect, useContext, useRef, createRef} from "react";
import {store} from '../context/store';
import {JWT} from "../constants/local-storage";
import {COLOR_GRAY_BANNER_BACKGROUND} from "../constants/general-constants";
import CircularProgress from '@material-ui/core/CircularProgress';

export default function ForgeViewer({urn, viewerLeft,viewerRight, viewerZIndex,	viewerTop, viewerBottom, loadFunction}){
	
	const globalState = useContext(store);
	
	const viewerId = useRef(null);
	const [displaySpinner, setDisplaySpinner] = useState("flex");
	
	let viewer = null;
	
	useEffect(() => {
		
		getForgeClient(urn);
		//return () => {
		//	try{
		//		viewer.tearDown();
	  //  	viewer.finish();
	  //  	viewer = null;
	  //  }
	  //  catch(e){}
		//}
		
	}, [urn]);
	
	const  ToolbarExtension = (viewer, options) => {
		window.Autodesk.Viewing.Extension.call(this, viewer, options);
	};
	
	const config = {
    extensions: []
	};
	
	const loadDocument = (urn, token) => {
		if(urn != null && urn.length > 5){
			console.log(urn);
			var options = {
		    env: 'AutodeskProduction',
		   	accessToken:token.access_token
			};
			
			window.Autodesk.Viewing.Initializer(options, function() {
				
			    viewer = new window.Autodesk.Viewing.Private.GuiViewer3D(viewerId.current, config);
			    viewer.loadExtension('Autodesk.DocumentBrowser');
			    var startedCode = viewer.start();
			    if (startedCode > 0) {
			        console.error('Failed to create a Viewer: WebGL not supported.');
			        return;
			    }
			   
					ToolbarExtension.prototype = Object.create(window.Autodesk.Viewing.Extension.prototype);
					window.Autodesk.Viewing.Document.load(urn, onDocumentLoadSuccess, onDocumentLoadFailure);
  				viewer.fitToView();
  				
					setDisplaySpinner("none");
			});
		}
	}
	
	const onDocumentLoadSuccess = (viewerDocument) => {
  let defaultModel = viewerDocument.getRoot().getDefaultGeometry();

  viewer.loadDocumentNode(viewerDocument, defaultModel).then(() => {
    console.log("Model loaded!");

    viewer.getObjectTree((tree) => {
      tree.enumNodeChildren(tree.getRootId(), (dbId) => {
        viewer.getProperties(dbId, (props) => {
          console.log("Node:", props);
        });
      }, true);
    });

    if (loadFunction) {
      loadFunction(defaultModel);
    }

    setDisplaySpinner("none");
  });
};
	
	const onDocumentLoadFailure = (e) => {
	    console.error('Failed fetching Forge manifest');
	};
  
 const authenticateForge = (clientId, clientSecret, urn) => {
	  	let details = {
	  	 	"grant_type":'client_credentials',
	  	 	"scope":"data:read"
	  	};
  	
			let postBody = [];
			for (var property in details) {
			  var encodedKey = encodeURIComponent(property);
			  var encodedValue = encodeURIComponent(details[property]);
			  postBody.push(encodedKey + "=" + encodedValue);
			}
			postBody = postBody.join("&");
		 
		 	fetch("https://developer.api.autodesk.com/authentication/v2/token", {
	    	method:"POST",
	    	headers:{
	    		"Authorization":"Basic " + btoa(clientId + ":" + clientSecret),
		  		'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8"
		  	},
	    	body:postBody
	    })
		  .then(async response => {
		  	const data = await response.json();
		  	if(data){
		  		console.log("Data");
		  		console.log(data);
		  		loadDocument("urn:" + urn, data);

		  	}
		  })
		  .catch(error => {
		  	
		  });
  };
  

	
	const getForgeClient = (urn) => {
		console.log(urn);
		 fetch('/resolutionsoftwareplatform/forgegetclient', {
	    	method:"GET",
		  	headers:{
		  		'Authorization': localStorage.getItem(JWT)
		  	}
	    })
		  .then(async response => {
		  	const data = await response.json();
		  	authenticateForge(data.clientId, data.clientSecret, urn);
		  })
		  .catch(error => {
		  	console.log("Error Loading OauthToken");
		  });
	};
	

	const frame = {
		position:"absolute",
		display:"flex",
		left:viewerLeft,
		top:viewerTop,
		zIndex:viewerZIndex,
		bottom:viewerBottom,
		right:viewerRight
	};
	
	const thisContainer = {
		display:"flex",
		width:"100%",
		height:"100%",
		backgroundColor:'rgba(255, 255, 255, 0.3)',
		//borderTop:"1px solid white",
		flexDirection:"column"
	};
	
	const spinnerContainer = {
			width:"100%",
			height:"100%",
			alignItems:"center",
			justifyContent:"space-around",
			marginTop:"0px",
			color:"#fff"
	};
	
	return (
		<div style={thisContainer}>
			<div style={{...spinnerContainer, display:displaySpinner}}>
				<CircularProgress
					color="inherit"
				>
				</CircularProgress>
			</div>
			<div ref={viewerId} style={frame}>
				
			</div>
 		</div>
	);
}